import {FormattedMessage} from 'react-intl'

const ReportError = ({error, location}: any) => {
  return (
    <button
      className='show-chat btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
      style={{fontFamily: 'inherit !important', width: 'auto', padding: 'inherit'}}
      data-id={'new'}
    >
      <FormattedMessage id='ERROR.SEND_REPORT' />
    </button>
  )
}

export {ReportError}
